export default "__VITE_ASSET__BtaRE1Is__"